export default __webpack_public_path__ + "static/media/fa-solid-900.a480ec97.ttf";